import {
  FolderStakeholderType,
  FolderStakeholdersInputValuesType,
} from "src/core/components/pdf/shared/types";
import { EReputationAnalysisStatus, EReputationCategory } from "src/core/constants/eReputation";
import { CustomRiskLevel } from "src/core/constants/risk";

export const getRiskBackgroundColor = (risk: CustomRiskLevel): string => {
  switch (risk) {
    case CustomRiskLevel.LOW:
      return "#00D6A8";
    case CustomRiskLevel.MEDIUM:
    case CustomRiskLevel.NORMAL:
      return "#F3AC60";
    case CustomRiskLevel.HIGH:
      return "#FE6447";
    default:
      return "#0A1A53";
  }
};

export const getRiskTextColor = (risk: CustomRiskLevel): string => {
  switch (risk) {
    case CustomRiskLevel.LOW:
      return "#00A67E";
    case CustomRiskLevel.MEDIUM:
    case CustomRiskLevel.NORMAL:
      return "#C77D30";
    case CustomRiskLevel.HIGH:
      return "#C72500";
    default:
      return "#0A1A53";
  }
};

export const getStakeholderFieldValue = (
  inputValues: FolderStakeholdersInputValuesType,
  fieldCode: string
): string => {
  return inputValues.find((iv) => iv.inputField?.fieldCode === fieldCode)?.stringValue ?? "-";
};

type StakeholderAlerts = {
  isPepHit: boolean; // Est-ce qu'il y a un hit PEP ?
  pepStatus?: EReputationAnalysisStatus; // Statut de l'alerte PEP
  isSanctionHit: boolean; // Est-ce qu'il y a un hit Sanction ?
  sanctionStatus?: EReputationAnalysisStatus; // Statut de l'alerte Sanction
};

export const getStakeholderAlerts = (stakeholder: FolderStakeholderType): StakeholderAlerts => {
  const eReputation = stakeholder.entity.eReputation;
  if (!eReputation)
    return {
      isPepHit: false,
      isSanctionHit: false,
    };

  const pepEntry = eReputation.entries.find(
    (entry) => entry.category.code === EReputationCategory.PEP
  );
  const sanctionEntry = eReputation.entries.find(
    (entry) => entry.category.code === EReputationCategory.SANCTION
  );

  const isPepHit = pepEntry?.providerResult === true;
  const isSanctionHit = sanctionEntry?.providerResult === true;

  const pepStatus = isPepHit ? (pepEntry?.analysis?.name as EReputationAnalysisStatus) : undefined;
  const sanctionStatus = isSanctionHit
    ? (sanctionEntry?.analysis?.name as EReputationAnalysisStatus)
    : undefined;

  return { isPepHit, pepStatus, isSanctionHit, sanctionStatus };
};
